export default __webpack_public_path__ + "static/media/mangementimage.5a6ea6e6.png";